import { assert, log } from '../app/logger.js';
import { HTMLControl } from '../controls/html_control.js';
import { LocationPlain } from '../data/location_plain.js';
import { animateUILoading } from '../ui/ui_loader.js';
import { typeOf } from '../util/util.js';
import { LocMarkupBase } from './loc_markup_base.js';

class LocBase extends HTMLControl {
  static get selectors() {
    return this.MarkupClass.selectors;
  }

  static get elements() {
    const s = this.selectors;
    return {
      coverImage: s.CoverImage,
    };
  }

  static get MarkupClass() {
    return LocMarkupBase;
  }

  static getMarkupGenerator(loc = new LocationPlain()) {
    return new this.MarkupClass(loc, {
      typeOf,
      log,
      assert,
    });
  }

  set(loc) {
    if (loc == this.loc) {
      return false;
    }
    this.loc = loc;
    this.pipeUI();
    return true;
  }

  setCover(url) {
    this.setCoverPromise = new Promise(resolve => {
      const eventHandler = () => {
        this.coverImage.removeEventListener('load', eventHandler);
        this.coverImage.removeEventListener('error', eventHandler);
        resolve();
      };
      this.coverImage.addEventListener('load', eventHandler);
      this.coverImage.addEventListener('error', eventHandler);
      this.coverImage.src = url;
    });
    animateUILoading(this.coverImage, this.setCoverPromise);
  }

  fireClose() {
    this.dispatchEvent('locstickpanelclose');
  }

  pipeUI() {}

  static get markup() {
    return this.getMarkupGenerator()[`${this.markupType}Markup`];
  }

  static get snippets() {
    return this.getMarkupGenerator()[`${this.markupType}MarkupSnippets`];
  }

  static get dynamicSnippets() {
    return this.MarkupClass.filterDynamicSnippets(this.snippets);
  }

  get markupGenerator() {
    return this.constructor.getMarkupGenerator(this.loc);
  }

  loc;
  setCoverPromise = Promise.resolve();
}

export { LocBase };
